/* eslint-disable array-callback-return */
import { Component } from 'react'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { listJobTitles } from '../../../../insfrastructure/services/jobs-titles'
import { listBenefits } from '../../../../insfrastructure/services/benefits'
import { listCourses } from '../../../../insfrastructure/services/courses'
import ResponseModal from '../../../components/response-modal'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { listSavedJobs, updateSavedJob } from '../../../../insfrastructure/services/saved-jobs'
import { applyToJob, jobApplies } from '../../../../insfrastructure/services/job-applies'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import savedIcon from '../../../../assets/icons/saved.svg'
import notSavedIcon from '../../../../assets/icons/not-saved.svg'
import './styles.sass'

class JobOfferDetails extends Component<any> {
  state: Record<string, any> = {
    job_types: {},
    job_titles: {},
    benefits: {},
    education_levels: {},
    courses: {},
    skills: {},
    offer: {
      basic_info: {},
      benefits: {},
      requirements: {}
    }
  }

  BRLReal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  async componentDidMount() {
    this.getStaticValues();
    await this.listJobTitles();
    await this.listBenefits();
    await this.getUserData();
    await this.retriveOffer();
    await this.checkUserApplication();
    await this.checkSavedJob();    
  }

  getUserData = async () => {
    const auth_token = localStorage.getItem('auth_token');
    if(!auth_token) return;
    
    let state: any = { usertype: parseJwt(auth_token).profiles[0] };
    
    if (state.usertype === 'candidate') {
      const candidate = await retrieveCandidate();
      state.user_data = candidate;
    };

    this.setState(state);
  }

  checkSavedJob = async () => {
    if (this.state.usertype !== 'candidate') return;

    try {
      const response = await listSavedJobs(localStorage.getItem('candidate_id'));

      this.setState({ saved: response.filter(x => this.props.params?.offer_id === x.job_post+'').length > 0 });
    } catch (error) {}
  }

  toggleSavedJob = async () => {
    try {
      await updateSavedJob({
        candidate_id: localStorage.getItem('candidate_id')+'',
        job_post_id: this.props.params?.offer_id,
        is_saved: !this.state.saved
      });

      this.setState({ saved: !this.state.saved });
    } catch (error) {}
  }

  checkUserApplication = async () => {    
    if (this.state.usertype !== 'candidate') return;

    const auth_token = localStorage.getItem('auth_token');
    if(!auth_token) return;

    const applications = await jobApplies();

    this.setState({ user_applied: applications.results.filter(x => this.props.params?.offer_id === x.jobpost_id + '').length > 0 });
  }

  retriveOffer = async () => {
    try {
      this.setState({ loading: true });

      const offerResponse = (await listJobs({ id: this.props.params?.offer_id })).data[0] as any;

      console.log(offerResponse);

      const offer = {
        basic_info: {
          company_id: offerResponse.company.id,
          company_name: offerResponse.company.name,
          job_title_id: parseInt(offerResponse.jobTitle.id),
          job_type: offerResponse.jobType.toLowerCase(),
          job_description: offerResponse.jobDescription,
          quantity: offerResponse.quantity
        },
        benefits: {
          salary: offerResponse.salary,
          comission: offerResponse.comission,
          show_salary: offerResponse.showSalary,
          benefits: offerResponse.jobBenefits.map((x: any) => ({
            benefit_id: x.benefitId,
            value: x.value,
            time_unit: x.timeUnit?.toLowerCase(),
            description: x.description
          }))
        },
        requirements: {
          minimum_education: offerResponse.minimumEducation?.toLowerCase(),
          minimum_experience: offerResponse.minimumExperience?.toString() || '0',
          required_skills: offerResponse.jobSkills.filter((x: any) => x.skillType === 'REQUIRED').map((x: any) => parseInt(x.skill.id)),
          desired_skills: offerResponse.jobSkills.filter((x: any) => x.skillType === 'DESIRED').map((x: any) => parseInt(x.skill.id))
        }
      };

      console.log(offer);

      this.setState({ offer });
      
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 500);
    }
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;

      let skills: any = {};
 
      staticValues.skills.map(item => {
        skills[item.id] = item.name;
      });
      
      this.setState({ job_types: staticValues.job_type, education_levels: staticValues.education_level, courses: staticValues.em_course, skills });
    } catch (error) {}
  }

  listJobTitles = async () => {
    try {
      const response = await listJobTitles();
      
      let job_titles: any = {};

      response.results.map(item => {
        job_titles[item.id] = item.name;
      });

      console.log(job_titles);
      

      this.setState({ job_titles });
    } catch (error) {}
  }

  listBenefits = async () => {
    try {        
      let benefits: any = {};

      const response = await listBenefits();

      response.results.map(item => {
        benefits[item.id] = item.name;
      });

      this.setState({ benefits });
    } catch (error) {}
  }

  async listCourses() {
    try {
      const results = await listCourses();

      let courses: any = {};
      
      results.results.map(item => {
        courses[item.id] = item.course_name;
      });

      this.setState({ courses });
    } catch (error) {}
  }

  onSubmit = async () => {
    try {
      this.setState({ loading: true });

      await applyToJob(this.props.params?.offer_id);

      let responseData = {
        type: 'success',
        title: 'Candidatura realizada com sucesso!',
        text: () => <></>
      };
        
      setTimeout(() => {
        this.setState({ loading: false, responseData });
      });
    } catch (error) {
      let responseData = {
        type: 'error',
        title: 'Ocorreu um erro inesperado',
        text: () => <></>
      };

      this.setState({ loading: false, responseData });
    }
  }

  render() {
    return (
      <div className='job-offer-details company-page'>
      <div className='summary block'>
        <div className='title-row'>
          <h3>Vaga</h3>
          {this.state.usertype && this.state.usertype === 'candidate' &&
          <img onClick={this.toggleSavedJob} src={this.state.saved ? savedIcon : notSavedIcon} alt={this.state.saved ? 'saved' : 'not-saved'} />}
        </div>
        <div className='section basic-info-section'>
          <div className='section-header'>
            <h4>Dados básicos:</h4>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Nome da vaga:</p>
              <b>{this.state.job_titles[this.state.offer.basic_info.job_title_id]}</b>
            </div>
            <div className='column'>
              <p>Quantidade de vagas:</p>
              <b>{this.state.offer.basic_info.quantity} vaga{this.state.offer.basic_info.quantity > 1 ? 's' : ''}</b>
            </div>
            <div className='column'>
              <p>Tipo de contratação:</p>
              <b>{this.state.job_types[this.state.offer.basic_info.job_type?.toLowerCase()]}</b>
            </div>
          </div>
          <div className='about-section'>
            <h4>Sobre a vaga:</h4>
            <div dangerouslySetInnerHTML={{__html: this.state.offer.basic_info.job_description}} />
          </div>
        </div>
        <div className='section benefits-section'>
          <div className='section-header'>
            <h4>Salário e benefícios:</h4>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Salário:</p>
              <b className='salary'>
                {
                  this.state.offer.benefits.show_salary ?
                  this.BRLReal.format(this.state.offer.benefits.salary) : 
                  'À combinar'
                }
              </b>
            </div>
            <div className='column'>
              <p>Benefícios:</p>
              <div className='selections'>
                {this.state.offer.benefits.benefits?.map((benefit: any, index: number) =>
                <b key={'benefit_'+benefit.benefit_id+'_'+index} className='selection'>{this.state.benefits[benefit.benefit_id]}</b>)}
              </div>
            </div>
          </div>
        </div>
        <div className='section requirements-section'>
          <div className='section-header'>
            <h4>Requisitos:</h4>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Escolaridade:</p>
              <b>{this.state.education_levels[this.state.offer.requirements.minimum_education]}</b>
            </div>
            <div className='column'>
              <p>Experiência mínima:</p>
              <b>{
                this.state.offer.requirements.minimum_experience === '0' ? 
                'Indiferente' : 
                `${parseInt(this.state.offer.requirements.minimum_experience)} ${parseInt(this.state.offer.requirements.minimum_experience) < 2 ? 'ano' : 'anos'}`
              }</b>
            </div>
          </div>
          <div>
            <p>Habilidades obrigatórias:</p>
            <div className='selections'>
              {this.state.offer.requirements.required_skills?.map((skill: any) =>
              <b key={'required_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div>
            <p>Habilidades opcionais:</p>
            <div className='selections'>
              {this.state.offer.requirements.desired_skills?.map((skill: any) =>
              <b key={'desired_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
            </div>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Cursos recomendados:</p>
              <div className='selections'>
                {this.state.offer.requirements.recommended_courses?.map((course: any) =>
                <b key={'course_'+course} className='selection'>{this.state.courses[course+'']}</b>)}
              </div>
            </div>
          </div>
        </div>
        {
          this.state.usertype && this.state.usertype === 'candidate' && this.state.user_applied === false &&
          <div className='bottom-btns'>
            <button className='primary' onClick={this.onSubmit}>Candidatar-se</button>
          </div>
        }
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => {
          this.setState({ responseData: null });
          this.state.responseData?.type === 'success' && this.props.navigate('/offers');
        }} />
      </div>
      </div>
    )
  }
}

export default withRouter(JobOfferDetails);